'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./dist/shared.prod.cjs')
} else {
  module.exports = require('./dist/shared.cjs')
}
